<template>
  <vx-card :title="assignment.title" :subtitle="assignment.groups ? `المجموعات ( ${assignment.groups.join(', ')} )` : null">
    <div slot="actions" class="flex">
      <vs-dropdown v-if="isTeacher" vs-drop-right vs-custom-content class="effect-dropdown cursor-pointer" vs-trigger-click>
        <feather-icon icon="MoreHorizontalIcon" svg-classes="w-6 h-6" />

        <vs-dropdown-menu>
          <vs-dropdown-item @click="$emit('edit', assignment)">
            <feather-icon icon="EditIcon" svgClasses="w-4 h-4"></feather-icon>
            <span class="ml-2">تعديل البيانات</span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="$emit('delete', assignment)">
            <feather-icon icon="TrashIcon" svgClasses="w-4 h-4"></feather-icon>
            <span class="ml-2">حذف</span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <div>
      <div class="flex flex-wrap justify-end">
<!--        <p class="w-full mb-4 md:w-3/5 truncate">{{assignment.body}}</p>-->
        <div class="md:w-1/5 py-2 px-4 border border-t-0 border-b-0 border-r-0 border-solid d-theme-border-grey-light">
          <p class="text-sm mb-2">الموعد النهائي</p>
          <p class="text-xl">{{assignment.deadline | date}}</p>
        </div>
        <div class="md:w-1/5 py-2 px-4 border border-t-0 border-b-0 border-r-0 border-solid d-theme-border-grey-light">
          <p class="text-sm mb-2">الدرجة</p>
          <p class="text-xl">{{assignment.mark}}</p>
        </div>
      </div>
<!--      <p>{{assignment.body}}</p>-->
<!--      <div class="mt-4 flex text-center justify-around py-4 border border-solid d-theme-border-grey-light rounded">-->
<!--        <div class="flex-grow">-->
<!--          <p class="mb-2">الموعد النهائي</p>-->
<!--          <p class="text-xl">{{assignment.deadline | date}}</p>-->
<!--        </div>-->
<!--        <div class="flex-grow border border-t-0 border-b-0 border-r-0 border-solid d-theme-border-grey-light">-->
<!--          <p class="mb-2">الدرجة</p>-->
<!--          <p class="text-xl">{{assignment.mark}}</p>-->
<!--        </div>-->
<!--      </div>-->
      <vs-alert v-if="!assignment.stop_at_deadline && afterRealDeadline && !isCompleted" active="true" class="mt-2" color="primary">يوجد مهلة لتسليم الواجب {{assignment.days_after_deadline}} أيام بعد الموعد النهائي</vs-alert>
    </div>
    <div slot="footer" class="flex">
      <vs-button v-if="isTeacher" @click="openAssignment('Correction')" class="ml-auto bg-primary-gradient hover:shadow-primary" icon="icon-chevrons-left" icon-pack="feather" icon-after>تصحيح الواجب</vs-button>
      <vs-button v-else-if="!isCompleted" @click="openAssignment()" class="ml-auto bg-primary-gradient hover:shadow-primary" icon="icon-chevrons-left" icon-pack="feather" icon-after>عرض الواجب</vs-button>
      <vs-button v-else @click="openAssignment('Result')" class="ml-auto bg-primary-gradient hover:shadow-primary" icon="icon-chevrons-left" icon-pack="feather" icon-after>عرض النتيجة</vs-button>
    </div>
  </vx-card>
</template>

<script>
    export default {
        name: 'assignmentItem',
        props: {
            assignment: {
                type: Object,
                required: true
            }
        },
        computed: {
            afterRealDeadline() {
              return (this.$store.state.date.getTime() > new Date(this.assignment.deadline).getTime()+ (24*60*60*1000))
            },
            isCompleted(){
              const day = 24*60*60*1000
              if (this.assignment.stop_at_deadline) {
                return (this.$store.state.date.getTime() > new Date(this.assignment.deadline).getTime()+day)
              }
              return (this.$store.state.date.getTime() > new Date(this.assignment.deadline).getTime()+ (day*(this.assignment.days_after_deadline+1)) )
            }
        },
        methods: {
            openAssignment(name = '') {
                const params = {course_id: this.$route.params.course_id, assignment_id: this.assignment.id}
                this.$router.push({ name: `assignment${name}`, params})
            }
        }
    }
</script>
